import { defineMessages } from 'react-intl';

export default defineMessages({
    idCondition: {
        id: 'portal.views.dashboard-table.new-claim-report.special-conditions.id-condition',
        defaultMessage: 'ID condition',
    },
    text: {
        id: 'portal.views.dashboard-table.new-claim-report.special-conditions.text',
        defaultMessage: 'Title / Text claim',
    },
    description: {
        id: 'portal.views.dashboard-table.new-claim-report.special-conditions.description',
        defaultMessage: 'Description / Original redaction',
    },
    actionButton: {
        id: 'portal.views.dashboard-table.new-claim-report.special-conditions.modal.button',
        defaultMessage: 'Accept',
    },
    seeMore: {
        id: 'portal.views.dashboard-table.new-claim-report.special-conditions.see-more',
        defaultMessage: '...see more',
    }
});
